module.exports = __webpack_public_path__ + "static/media/Metro.ed6e9775.mp3";